import { addCommaNumber } from './addCommaNumber'

export const formatStatisticRowNumber = (
    data: number | null,
    toFixed: boolean,
    sign?: string
) => {
    const returnValue: number | null = data
    let returnSign = sign
    if (!returnSign) {
        returnSign = ''
    }
    //null >> -
    if (!returnValue && returnValue !== 0) {
        return '-'
    }

    if (toFixed && returnValue === 0) {
        return '0.00' + returnSign
        //0 >> 0
        //0 >> 0
    } else if (returnValue === 0) {
        return '0' + returnSign
        //0.00 >> 0.00
        //0.00%>> 0.00%
    } else if (toFixed) {
        return `${addCommaNumber(returnValue.toFixed(2))} ${returnSign}`
    } else {
        return `${addCommaNumber(returnValue)} ${returnSign}`
    }
}
